module.exports = __webpack_public_path__ + "img/cjlb.b1660bce.png";